import { useLocation, useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import {
  Box,
  Tabs,
  Tab,
  TextField,
  Button,
  CardMedia,
  Input,
  Select,
  MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { ChangeEvent, useEffect, useState } from "react";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Customer } from "../../types/General";
import {
  useAddCustomerMutation,
  useLazyGetCustomerByIdQuery,
  useUpdateCustomerMutation,
} from "../../services/customer";
import { showError, showToast, showWarning } from "../../constants/toasts";
import { UploadMedia } from "../../utils/mediaUpload";
import CompanyDocumentation from "../../features/manageCustomers/CustomerDocs";
import CustomerProperty from "../../features/manageCustomers/CustomerProperty";
import {
  CUSTOMER_ONBOARDING_STEP,
  PROPERTY_TYPE,
  ROLES,
  USER_STATUS,
} from "../../utils/enums";
import { isString, isValidInput } from "../../utils/validations";
import countries from "../../json/country.json";
import ViewDocModal from "../../Modals/viewDocModal";
import usePermission from "../../hooks/usePermission";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const AddCustomer = () => {
  const { id } = useParams();

  const navigate = useNavigate();
  const location = useLocation();
  usePermission({ label: "Manage Customers", page_permission: "isAdd" });
  const [addCustomer] = useAddCustomerMutation();
  const [updateCustomer] = useUpdateCustomerMutation();
  const [getCustomerById] = useLazyGetCustomerByIdQuery();

  const [valueTabs, setValueTabs] = React.useState(0);
  const [userId, setUserId] = useState("");
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
    // return;
    // if ((newValue === 1 || newValue === 2) && (id || userId)) {
    //   setValueTabs(newValue);
    // } else {
    //   showWarning("Please add Personal Details first");
    // }
  };

  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [profileImage, setProfileImage] = useState("");
  const [phone, setPhone] = useState("");
  const [buttonType, setButtonType] = useState("");
  const [dialCode, setDialCode] = useState("+971");
  const [CustomerDetail, setCustomerDetail] = useState<Customer | null>(null);
  const [openDocView, setOpenDocView] = useState(false);
  const [docViewImage, setDocViewImage] = useState("");

  const [selectedCountry, setSelectedCountry] = useState("");

  const handleChangeCountry = (event: any) => {
    setSelectedCountry(event.target.value);
  };
  // const handleNextTab = () => {
  //   setValueTabs((prevIndex) => prevIndex + 1); // Move to the next tab
  // };

  const handleChangePhone = (phone: any, country: any) => {
    setPhone(phone?.replace(country.dialCode, ""));
    setDialCode(country?.dialCode);
  };

  const handleProfileUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    if (!file) {
      setProfileImage("");
      return;
    }

    const imageUrl = (await UploadMedia(file)) as any;
    if (imageUrl?.data) {
      setProfileImage(imageUrl?.data || "");
    }
  };

  const getData = async (id: string) => {
    setLoading(true);
    try {
      const response = await getCustomerById({
        id,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        setCustomerDetail(response?.data || null);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (CustomerDetail?.phone) {
      setPhone(CustomerDetail?.phone || "");
      setProfileImage(CustomerDetail?.image || "");
      setDialCode(CustomerDetail?.countryCode || "");
      setSelectedCountry(CustomerDetail?.country || "");
    }
  }, [CustomerDetail]);

  useEffect(() => {
    if (id) {
      getData(id);
    }
  }, []);

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      name: CustomerDetail?.fullName || "",
      address: CustomerDetail?.address || "",
      email: CustomerDetail?.email || "",
      city: CustomerDetail?.city || "",
      country: CustomerDetail?.country || "",
    },

    validationSchema: Yup.object({
      name: Yup.string()
        .required("This field is required")
        .min(2, "Minimum 2 characters are required"),
      email: Yup.string()
        .required("Email is required!")
        .matches(
          /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
          "Please enter a valid email address!"
        ),
      address: Yup.string()
        .required("This field is required")
        .min(3, "Minimum 3 characters are required"),
      city: Yup.string()
        .required("This field is required")
        .min(3, "Minimum 3 characters are required"),
      // country: Yup.string()
      //   .required("This field is required")
      //   .min(3, "Minimum 3 characters are required"),
    }),
    onSubmit: async (values: any) => {
      formik.setSubmitting(true);

      if (phone.length < 8) return;

      let body = {
        ...(profileImage ? { image: profileImage } : {}),
        fullName: values?.name || "",
        phone: phone || "",
        email: values?.email || "",
        address: values?.address || "",
        city: values?.city || "",
        // latitude: 0,
        // longitude: 0,
        countryCode: (dialCode.includes("+") ? "" : "+") + dialCode,
        country: selectedCountry || "",
        ...(id ? { userId: id } : {}),
        ...(!id ? { role: ROLES.USER } : {}),
      };

      try {
        let response;
        if (id) {
          // If ID exists, update customer
          response = await updateCustomer(body).unwrap();
        } else {
          // Else, add customer
          response = await addCustomer(body).unwrap();
        }
        if (response?.statusCode === 200) {
          setUserId(response?.data?._id || "");
          showToast(
            id ? "Customer updated successfully" : "Customer added successfully"
          );
          if (buttonType) {
            navigate(-1);
          } else {
            setValueTabs((prevIndex) => prevIndex + 1);
          }
        }
      } catch (error: any) {
        showError(error?.data?.message || "");
        console.log(error);
      }
    },
  });

  return (
    <MainContainer>
      <div className="main_title">
        <h1>{id ? "Update" : "Add"} Customer</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> -{" "}
          <span onClick={() => navigate("/manage-customers")}>
            Manage Customers
          </span>{" "}
          - {id ? "Update" : "Add"} Customer
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Personal Details" {...a11yProps(0)} />
              <Tab label="Property Details" {...a11yProps(1)} />
              <Tab label="Documents" {...a11yProps(2)} />
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards">
        <CustomTabPanel value={valueTabs} index={0}>
          <form className="form" onSubmit={formik.handleSubmit}>
            <div className="gap_p">
              <div className="control_group w_100">
                <label>Upload Image</label>
                {profileImage ? (
                  <div className="upload_image">
                    <div className="upload_image_holder">
                      <figure>
                        <CardMedia
                          component="img"
                          image={
                            profileImage
                              ? profileImage
                              : "/static/images/user_placeholder.png"
                          }
                          alt="photo"
                        />
                      </figure>
                      <CloseIcon
                        onClick={() => {
                          setProfileImage("");
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <label className="upload_image" htmlFor="icon-button-file">
                    <Input
                      sx={{ display: "none" }}
                      id="icon-button-file"
                      type="file"
                      inputProps={{
                        accept: "image/png,image/jpeg",
                      }}
                      onChange={(e: any) => {
                        handleProfileUpload(e);
                        e.target.value = null;
                      }}
                    />
                    <span className="upload_image_holder">
                      <figure className="add_img">
                        <img
                          src="/static/images/user_placeholder.png"
                          alt="icon"
                        />
                        <span className="upload_img_icon">
                          <img src="/static/images/edit2_icon.svg" alt="icon" />
                        </span>
                      </figure>
                    </span>
                  </label>
                )}
              </div>
              {/* {!profileImage && error ? (
                <h6 className="err_msg">This field is required</h6>
              ) : (
                ""
              )} */}
              <div className="control_group w_50">
                <label>Name</label>
                <TextField
                  placeholder="Enter Name"
                  variant="outlined"
                  className="text_field"
                  fullWidth
                  hiddenLabel
                  name="name"
                  id="name"
                  inputProps={{ maxLength: 80 }}
                  value={formik.values.name}
                  onChange={(val) => {
                    if (
                      isValidInput(val.target.value) &&
                      isString(val.target.value)
                    ) {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  helperText={formik.touched.name && formik.errors.name}
                />
              </div>
              <div className="control_group w_50">
                <label>Email Id</label>
                <TextField
                  placeholder="Enter Email Id"
                  hiddenLabel
                  fullWidth
                  className="text_field"
                  name="email"
                  id="email"
                  inputProps={{ maxLength: 80 }}
                  value={formik.values.email}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  helperText={formik.touched.email && formik.errors.email}
                />
              </div>

              <div className="control_group w_50">
                <label>Phone Number</label>
                <PhoneInput
                  enableSearch
                  value={dialCode + phone}
                  country={"uae"}
                  inputClass="phoneInput"
                  onChange={(phone, country) =>
                    handleChangePhone(phone, country)
                  }
                  inputStyle={{ width: "100%" }}
                  buttonClass="phoneBtn"
                  placeholder="Phone Number"
                />
                {!phone && error ? (
                  <h6 className="err_msg">This field is required</h6>
                ) : (
                  ""
                )}
                {phone.length >= 1 && phone.length < 8 && error ? (
                  <h6 className="err_msg">Please enter a valid phone number</h6>
                ) : (
                  ""
                )}
              </div>
              <div className="control_group w_50">
                <label>Address</label>
                <TextField
                  placeholder="Enter Address"
                  hiddenLabel
                  fullWidth
                  className="text_field"
                  name="address"
                  id="address"
                  inputProps={{ maxLength: 80 }}
                  value={formik.values.address}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  helperText={formik.touched.address && formik.errors.address}
                />
              </div>
              <div className="control_group w_50">
                <label>City</label>
                <TextField
                  placeholder="Enter City"
                  hiddenLabel
                  fullWidth
                  className="text_field"
                  name="city"
                  id="city"
                  inputProps={{ maxLength: 80 }}
                  value={formik.values.city}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  helperText={formik.touched.city && formik.errors.city}
                />
              </div>

              <div className="control_group w_50">
                <label>Country</label>

                <Select
                  fullWidth
                  value={selectedCountry}
                  displayEmpty
                  onChange={handleChangeCountry}
                >
                  <MenuItem value="">Select Country</MenuItem>
                  {countries?.countries?.map((item: string) => (
                    <MenuItem value={item}>{item}</MenuItem>
                  ))}
                </Select>
                {!selectedCountry && error ? (
                  <h6 className="err_msg">This field is required</h6>
                ) : (
                  ""
                )}

                {/* <TextField
                  placeholder="Enter Country"
                  hiddenLabel
                  fullWidth
                  name="country"
                  id="country"
                  className="text_field"
                  inputProps={{ maxLength: 100 }}
                  value={formik.values.country}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  helperText={formik.touched.country && formik.errors.country}
                /> */}
              </div>
            </div>
            <div className="form_btn">
              <Button
                className="btn btn_primary"
                onClick={() => setError(true)}
                type="submit"
              >
                Next
              </Button>

              {id ? (
                <Button
                  className="btn btn_primary"
                  onClick={() => {
                    setButtonType("Submit");
                    setError(true);
                  }}
                  type="submit"
                >
                  Submit
                </Button>
              ) : null}
            </div>
          </form>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <CustomerProperty
            userId={userId || id || ""}
            setValueTabs={setValueTabs}
            update={location.pathname?.includes("/edit") ? true : false}
          />
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={2}>
          <CompanyDocumentation
            userId={userId || id || ""}
            setValueTabs={setValueTabs}
            mode="customer"
            view={false}
            setOpenDocView={setOpenDocView}
            setDocViewImage={setDocViewImage}
          />
        </CustomTabPanel>
      </div>
      <ViewDocModal
        open={openDocView}
        onClose={() => setOpenDocView(false)}
        imageUrl={docViewImage || ""}
      />
    </MainContainer>
  );
};

export default AddCustomer;
